document.addEventListener('DOMContentLoaded', function() {
  const selectors = {
    enquireNowButtons: '[data-enquire-now-button]',
    enquiryForm: '[data-enquiry-form]',
    enquiryFormProduct: '[data-enquiry-form-product]',
    enquiryFormClose: '[data-close-enquiry-form]',
    // Shopify Forms app root
    shopifyFormsRoot: '[data-form-root]',
    // Shopify Forms app hidden field selectors (by ID)
    shopifyFormVariantId: '#custom\\#product_dynamic_atc_link',
    shopifyFormProductUrl: '#custom\\#product_url',
    shopifyFormProductTitle: '#custom\\#product_title',
    shopifyFormProductOptions: '#custom\\#product_options'
  };

  const classes = {
    enquiryFormActive: 'DG-enquire-form-modal--active'
  };

  const enquireNowButtons = document.querySelectorAll(selectors.enquireNowButtons);
  const enquiryForm = document.querySelector(selectors.enquiryForm);
  const enquiryFormProduct = document.querySelector(selectors.enquiryFormProduct);
  const enquiryFormClose = document.querySelector(selectors.enquiryFormClose);

  // Get product data from page OR fetch it
  async function getProductData(productHandle) {
    // First try to get from page (PDP scenario)
    const productJson = document.querySelector('[data-product-json]');
    if (productJson) {
      return JSON.parse(productJson.textContent);
    }

    // If not on page, fetch it (PLP scenario)
    if (productHandle) {
      try {
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) throw new Error('Failed to fetch product');
        return await response.json();
      } catch (error) {
        console.error('Error fetching product data:', error);
        return null;
      }
    }

    return null;
  }

  // Get currently selected variant from page or default to first
  function getSelectedVariant(productData) {
    if (!productData) return null;

    // Check if there's a selected variant ID input (PDP only)
    const variantInput = document.querySelector('[name="id"]');
    if (variantInput && variantInput.value) {
      const variantId = parseInt(variantInput.value);
      const variant = productData.variants.find(v => v.id === variantId);
      if (variant) return variant;
    }

    // Fallback to first available variant
    return productData.variants && productData.variants[0];
  }

  // Format variant options as readable string, falling back to
  // custom product attribute properties when the variant is default.
  function formatVariantOptions(variant) {
    if (!variant) return '';

    const isDefault = !variant.options
      || (variant.options.length === 1 && variant.options[0] === 'Default Title');

    if (!isDefault) {
      const options = [];
      if (variant.option1) options.push(variant.option1);
      if (variant.option2) options.push(variant.option2);
      if (variant.option3) options.push(variant.option3);
      return options.join(' / ');
    }

    const customAttrs = document.querySelector('custom-product-attributes');
    if (!customAttrs) return '';

    const selectors = customAttrs.querySelectorAll('.option-selector');
    const selected = [];
    selectors.forEach((selector) => {
      const checked = selector.querySelector('input[type="radio"]:checked');
      const select = selector.querySelector('select');
      if (checked) {
        selected.push(checked.value);
      } else if (select && select.value) {
        selected.push(select.value);
      }
    });

    return selected.join(' / ');
  }

  // Fetch product markup for display
  const fetchProductMarkup = async (productHandle) => {
    try {
      const response = await fetch(`/products/${productHandle}?view=enquiry-form`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const html = await response.text();
      return html;
    } catch (error) {
      console.error('Error fetching product markup:', error);
      return null;
    }
  };

  // Wait for Shopify Forms app to load and pierce shadow DOM
  const waitForShopifyForm = (callback, maxAttempts = 20) => {
    let attempts = 0;
    const checkInterval = setInterval(() => {
      attempts++;

      // Find the shopify-forms-embed element
      const formsEmbed = enquiryForm.querySelector('shopify-forms-embed');

      if (formsEmbed && formsEmbed.shadowRoot) {
        // Pierce the shadow DOM to find the actual form
        const {shadowRoot} = formsEmbed;
        const variantField = shadowRoot.querySelector(selectors.shopifyFormVariantId);

        if (variantField || attempts >= maxAttempts) {
          clearInterval(checkInterval);
          callback(shadowRoot, !!variantField);
          return;
        }
      }

      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        callback(null, false);
      }
    }, 200); // Check every 200ms
  };

  // Populate Shopify Forms app hidden fields (pierce shadow DOM)
  const populateShopifyFormFields = async (productHandle) => {
    const productData = await getProductData(productHandle);
    const variant = getSelectedVariant(productData);

    if (!productData || !variant) {
      console.error('Could not get product/variant data');
      return false;
    }

    // Build product URL
    const productUrl = window.location.pathname.includes('/products/')
      ? window.location.origin + window.location.pathname
      : `${window.location.origin}/products/${productData.handle}`;

    const optionsStr = formatVariantOptions(variant);
    const productTitle = variant.title && !variant.title.includes('Default')
      ? `${productData.title} - ${variant.title}`
      : optionsStr
        ? `${productData.title} - ${optionsStr}`
        : productData.title;

    // Store data for persistent repopulation
    const formData = {
      variantId: variant.id,
      productUrl: productUrl,
      productTitle: productTitle,
      productOptions: optionsStr
    };

    // Function to populate fields and trigger events
    const populateFields = (shadowRoot) => {
      const variantIdField = shadowRoot.querySelector(selectors.shopifyFormVariantId);
      const productUrlField = shadowRoot.querySelector(selectors.shopifyFormProductUrl);
      const productTitleField = shadowRoot.querySelector(selectors.shopifyFormProductTitle);
      const productOptionsField = shadowRoot.querySelector(selectors.shopifyFormProductOptions);

      // Helper function to set value and dispatch events
      const setFieldValue = (field, value) => {
        if (!field) return;

        field.value = value;

        // Dispatch events to notify form frameworks
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
        field.dispatchEvent(new Event('blur', { bubbles: true }));

        // Mark as readonly to prevent clearing
        field.setAttribute('readonly', 'true');
        field.setAttribute('data-populated', 'true');

        // Remove required attribute if present
        field.removeAttribute('required');
        field.removeAttribute('aria-required');
      };

      if (variantIdField && variantIdField.value !== formData.variantId.toString()) {
        setFieldValue(variantIdField, formData.variantId);
      }

      if (productUrlField && productUrlField.value !== formData.productUrl) {
        setFieldValue(productUrlField, formData.productUrl);
      }

      if (productTitleField && productTitleField.value !== formData.productTitle) {
        setFieldValue(productTitleField, formData.productTitle);
      }

      if (productOptionsField && productOptionsField.value !== formData.productOptions) {
        setFieldValue(productOptionsField, formData.productOptions);
      }
    };

    // Wait for Shopify Forms to load, then populate hidden fields
    waitForShopifyForm((shadowRoot, formLoaded) => {
      if (!formLoaded || !shadowRoot) {
        console.warn('Shopify Forms did not load in time or shadow DOM not accessible');
        return;
      }

      // Apply custom styles to shadow DOM elements
      const formWrapper = shadowRoot.querySelector('section [data-sizing="form-wrapper"]');
      if (formWrapper) {
        formWrapper.style.paddingTop = '10px';
      }

      // Initial population
      populateFields(shadowRoot);

      // Hide field containers
      const variantIdField = shadowRoot.querySelector(selectors.shopifyFormVariantId);
      const productUrlField = shadowRoot.querySelector(selectors.shopifyFormProductUrl);
      const productTitleField = shadowRoot.querySelector(selectors.shopifyFormProductTitle);
      const productOptionsField = shadowRoot.querySelector(selectors.shopifyFormProductOptions);

      [variantIdField, productUrlField, productTitleField, productOptionsField].forEach(field => {
        if (!field) return;
        const container = field.closest('._formFieldContainer_1mxsl_5');
        if (container) container.style.display = 'none';
      });

      // Show the form now that it's ready
      const appBlock = enquiryForm.querySelector('.DG-enquire-form-modal__app-block');
      if (appBlock) {
        appBlock.classList.add('DG-enquire-form-modal__app-block--ready');
      }

      // Use interval to persistently check and repopulate fields
      const repopulateInterval = setInterval(() => {
        // Check if modal is still open
        if (!enquiryForm || !enquiryForm.classList.contains(classes.enquiryFormActive)) {
          clearInterval(repopulateInterval);
          return;
        }

        // Repopulate fields if they've been cleared
        populateFields(shadowRoot);
      }, 100); // Check every 100ms

      // Set up mutation observer as backup
      const observer = new MutationObserver(() => {
        populateFields(shadowRoot);
      });

      // Observe the form for any changes
      const form = shadowRoot.querySelector('form');
      if (form) {
        observer.observe(form, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
        });

        // Also add input event listeners to repopulate if cleared
        [variantIdField, productUrlField, productTitleField, productOptionsField].forEach(field => {
          if (field) {
            field.addEventListener('input', (e) => {
              e.preventDefault();
              populateFields(shadowRoot);
            }, true);
            field.addEventListener('change', (e) => {
              e.preventDefault();
              populateFields(shadowRoot);
            }, true);
            field.addEventListener('blur', (e) => {
              e.preventDefault();
              populateFields(shadowRoot);
            }, true);
          }
        });
      }

      console.log('Populated and monitoring form fields:', formData);
    });

    return true;
  };

  // Open enquiry form with product data
  const productEnquiry = async (productHandle) => {
    if (!enquiryForm) return;

    enquiryForm.classList.add(classes.enquiryFormActive);
    enquiryFormProduct.innerHTML = '<skeleton-loader></skeleton-loader>';

    // Fetch product markup for display
    const html = await fetchProductMarkup(productHandle);
    if (html) {
      enquiryFormProduct.innerHTML = html;

      const optionsEl = enquiryFormProduct.querySelector('[data-enquiry-product-options]');
      if (optionsEl) {
        const productData = await getProductData(productHandle);
        const variant = getSelectedVariant(productData);
        const optionsStr = formatVariantOptions(variant);
        if (optionsStr) {
          optionsEl.textContent = optionsStr;
        }
      }
    }

    // Populate Shopify Forms app fields with product data
    await populateShopifyFormFields(productHandle);
  };

  // Close enquiry form
  const closeEnquiryForm = () => {
    if (!enquiryForm) return;
    enquiryForm.classList.remove(classes.enquiryFormActive);
    enquiryFormProduct.innerHTML = '';
  };

  // Close form when clicking outside
  document.addEventListener('click', (event) => {
    if (!enquiryForm) return;
    if (!enquiryForm.classList.contains(classes.enquiryFormActive)) return;

    const isClickInside = enquiryForm.contains(event.target);
    const isEnquireButton = event.target.closest(selectors.enquireNowButtons);

    if (!isClickInside && !isEnquireButton) {
      closeEnquiryForm();
    }
  });

  // Close form when clicking close button
  if (enquiryFormClose) {
    enquiryFormClose.addEventListener('click', closeEnquiryForm);
  }

  // Close form on escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && enquiryForm && enquiryForm.classList.contains(classes.enquiryFormActive)) {
      closeEnquiryForm();
    }
  });

  // Add click handlers to all enquire now buttons
  enquireNowButtons.forEach(button => {
    button.addEventListener('click', function() {
      const productHandle = button.dataset.handle;
      if (!productHandle) return;
      productEnquiry(productHandle);
    });
  });
});

